import { render, staticRenderFns } from "./CustomerViewModal.vue?vue&type=template&id=693edd56&scoped=true"
import script from "./CustomerViewModal.vue?vue&type=script&lang=js"
export * from "./CustomerViewModal.vue?vue&type=script&lang=js"
import style0 from "./CustomerViewModal.vue?vue&type=style&index=0&id=693edd56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693edd56",
  null
  
)

export default component.exports